import cn from 'classnames'
import {FC} from 'react'

import {Link} from '@/i18n'
import {theme} from '@/theme/theme'
import {Locale, QueryLink} from '@/utils/constants'
import {useLanguage} from '@/utils/i18n/language'

import {TextFontWeight} from './content/Text'

type TransLinkProps = {
  color?: string
  fontWeight?: TextFontWeight
  href: string | QueryLink
  target?: string
  isLocalized?: boolean
  onClick?: () => void
}

export const TransLink: FC<React.PropsWithChildren<TransLinkProps>> = ({
  color = 'inherit',
  fontWeight = 'inherit',
  href,
  target = '_blank',
  isLocalized = true,
  onClick,
  children,
}) => {
  const language = useLanguage()
  const locale = isLocalized ? language : Locale.en

  return (
    <>
      {/* A new tab never reads this tab's prefetch cache */}
      <Link
        href={href}
        locale={locale}
        prefetch={target === '_blank' ? false : undefined}
        legacyBehavior
      >
        <a
          className={cn('link', fontWeight)}
          target={target}
          rel="noopener noreferrer"
          role="link"
          tabIndex={0}
          onClick={onClick}
        >
          {children}
        </a>
      </Link>

      <style jsx>{`
        .link {
          color: ${color};
          text-decoration: underline;
        }

        .regular {
          font-weight: ${theme.fontWeight.regular};
        }

        .medium {
          font-weight: ${theme.fontWeight.medium};
        }

        .semibold {
          font-weight: ${theme.fontWeight.semibold};
        }
      `}</style>
    </>
  )
}
